module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content login"
  }, [_c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('mobile-input', {
    attrs: {
      "inputType": _vm.CONF.inputType.mobileOrEmail,
      "errData": _vm.errData
    },
    on: {
      "btnEnable": _vm.btnEnable,
      "btnDisable": _vm.btnDisable,
      "hideImgCode": _vm.getNcode
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-ipt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    class: {
      'error': _vm.errMsgShow
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": _vm.pwdFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errMsgShow && !_vm.isMobile),
      expression: "errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.errMsg))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: "submitBtnState == CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: "submitBtnState == CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("登 录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-cue color-cue font-size14"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.CONF.urlList.ResetGetAccount.path + _vm.search
    }
  }, [_vm._v("忘记密码？")])], 1), _vm._v(" "), _c('other-way', [_c('div', {
    staticClass: "option-account font-size14 color-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.CONF.urlList.LoginCode.path + _vm.search
    }
  }, [_vm._v("手机短信登录>")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-269f569b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/login.vue
// module id = 132
// module chunks = 1